import { ZTooltip } from '../../widgets/ztooltip';
import amazon from 'assets/images/platforms/amazon.png';
import bigCommerce from 'assets/images/platforms/bigcommerce.png';
import shopware from 'assets/images/platforms/shopware.png';
import shopwired from 'assets/images/platforms/shopwired.png';
import api from 'assets/images/pricing/api.png';
import etsy from 'assets/images/pricing/etsy.png';
import prestashop from 'assets/images/pricing/logo_prestashop.png';
import wix from 'assets/images/pricing/logo_wix.png';
import magento from 'assets/images/pricing/magento.png';
import netsuite from 'assets/images/pricing/netsuite.png';
import opencart from 'assets/images/pricing/opencart.png';
import salesforce from 'assets/images/pricing/salesforce.png';
import shopify from 'assets/images/pricing/shopify.png';
import woocommerce from 'assets/images/pricing/woocommerce.png';
import React from 'react';
import { T } from 'src/shared/helpers';
import styled from 'styled-components';

interface BgProps {
    showCircle?: boolean;
}

const StyledImgIcon = styled.img`
    width: 34px;
    height: 34px;
    object-fit: contain;
`;

const StyledBackgroundCircle = styled.div<BgProps>`
    display: flex;
    align-items: center;
    width: 55px;
    height: 55px;
    justify-content: center;
    ${(props) => props.showCircle && `border-radius: 50%;`}
    ${(props) => props.showCircle && `background-color: #f3f5f6;`}
`;

const StyledTooltip = styled(ZTooltip)`
    width: 35px;
    height: 35px;
`;

const SalesChannelIcon = (eCommerce: string | undefined, tooltip: boolean, url?: string, key?: string, showCircle?: boolean) => {
    const renderIcon = (iconSrc: string, label: string) => {
        const content = (
            <StyledBackgroundCircle key={'bg' + key}>
                <StyledImgIcon src={iconSrc} title={url ? url : T._(label, 'Admin')} key={key}></StyledImgIcon>
            </StyledBackgroundCircle>
        );

        if (tooltip) {
            return (
                <StyledTooltip position='top' title={url ? url : T._(label, 'Admin')}>
                    {content}
                </StyledTooltip>
            );
        }
        return content;
    };

    switch (eCommerce) {
        case 'API':
            return renderIcon(api, 'API');
        case 'BIG_COMMERCE':
            return renderIcon(bigCommerce, 'Big Commerce');
        case 'ETSY':
            return renderIcon(etsy, 'Etsy');
        case 'MAGENTO':
        case 'MAGENTO1':
            return renderIcon(magento, 'Magento');
        case 'NET_SUITE':
            return renderIcon(netsuite, 'Net Suite');
        case 'NONE':
            return null;
        case 'OPEN_CART':
            return renderIcon(opencart, 'Open Cart');
        case 'PRESTA_SHOP':
            return renderIcon(prestashop, 'Presta Shop');
        case 'SHOPIFY':
            return renderIcon(shopify, 'Shopify');
        case 'WOO_COMMERCE':
            return renderIcon(woocommerce, 'Woo Commerce');
        case 'WIX':
            return renderIcon(wix, 'Wix');
        case 'SHOPWARE':
            return renderIcon(shopware, 'Shopware');
        case 'COMMERCE_CLOUD':
            return renderIcon(salesforce, 'Commerce Cloud');
        case 'SHOP_WIRED':
            return renderIcon(shopwired, 'ShopWired');
        case 'AMAZON':
            return renderIcon(amazon, 'Amazon');
        default:
            return null;
    }
};

export default SalesChannelIcon;
